import * as React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { State } from '../state';
import EventList from './EventList';
import Month from './Month';

const Row = styled.div`
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
        > * {
            width: calc(50% - 1rem);
        }
    }
`;

function MonthView(): JSX.Element {
    const date = useSelector((state: State) => state.calendar.selectedDate);
    return <div>
        <Row>
            <Month />
            <EventList date={date} />
        </Row>
    </div>;
}

export default React.memo(MonthView);
